import type { JSX, ReactNode } from 'react';
import { BrandMark } from './sidebar.js';

export interface AuthLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
}

/** Habillage commun des écrans `02` §1 (connexion, mot de passe oublié, réinitialisation). */
export function AuthLayout({ title, description, children }: AuthLayoutProps): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 py-12">
      <div className="flex w-full max-w-[380px] flex-col gap-6">
        <BrandMark className="justify-center" />
        <div className="rounded-xl border border-border bg-card p-6 text-card-foreground sm:p-8">
          <div className="mb-6 flex flex-col gap-1">
            <h1 className="text-xl font-semibold leading-7 tracking-[-0.01em]">{title}</h1>
            {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
